import dayjs, { Dayjs } from "dayjs"
import { ScheduledEvent, CrewMember, UpdateScheduledEventRequest } from "../scheduleApi"
import { findCrewMemberByEmail } from "../crewModel"

export type BuildMoveEventRequestParams = {
  event: ScheduledEvent
  targetDate: Dayjs
  crew: CrewMember[]
}

export const buildMoveEventRequest = ({
  event,
  targetDate,
  crew,
}: BuildMoveEventRequestParams): UpdateScheduledEventRequest | null => {
  const originalStart = dayjs(event.start)
  const originalEnd = dayjs(event.end)
  const daysDiff = targetDate.startOf('day').diff(originalStart.startOf('day'), 'day')

  if (daysDiff === 0) {
    return null
  }

  const newStart = originalStart.add(daysDiff, 'day')
  const newEnd = originalEnd.add(daysDiff, 'day')
  const durationMinutes = originalEnd.diff(originalStart, 'minutes')

  const crewLead = event.crewForemanEmail
    ? findCrewMemberByEmail(crew, event.crewForemanEmail)
    : null

  return {
    eventId: event.id,
    start: newStart.toISOString(),
    end: newEnd.toISOString(),
    dayStartTime: null,
    estimatedDurationInMinutes: durationMinutes,
    crewMemberIds: event.crewMemberIds || '',
    crewLeadId: crewLead?.id ?? null,
    workareaIds: event.workAreaIds || '',
    routeId: event.routeId,
    allDay: event.allDay,
    sendCrewLeadNotifications: event.sendCrewLeadNotifications,
    frozen: event.frozen,
  }
}
